import { makeStyles, tokens } from "@fluentui/react-components";

export const usePlaybookCardStyles = makeStyles({
  card: {
    padding: "1.5rem",
    backgroundColor: tokens.colorNeutralBackground2Selected,
    gap: 0,
  },
  cardSwitchRow: {
    marginTop: "1rem",
  },
  name: {
    fontWeight: "bold",
  },
});
